/**
 * Safe JSON stringification utilities with size limits
 */

/**
 * Safely stringify an object, catching circular references
 */
export function stringifySafe(
  obj: unknown,
  space: number | string = 2
): string {
  try {
    return JSON.stringify(obj, null, space);
  } catch (error) {
    // Handle circular references or other errors
    if (error instanceof Error && error.message.includes('circular')) {
      return '[Circular reference detected]';
    }
    return String(obj);
  }
}

/**
 * Generate a preview of JSON stringification up to a certain byte limit
 * Useful for avoiding expensive full stringify until needed
 */
export function stringifyPreview(
  obj: unknown,
  maxBytes = 1536,
  space: number | string = 2
): { preview: string; isTruncated: boolean } {
  try {
    const full = JSON.stringify(obj, null, space);

    if (full.length <= maxBytes) {
      return { preview: full, isTruncated: false };
    }

    // Truncate and add ellipsis
    const truncated = full.slice(0, maxBytes - 4) + '\n...';
    return { preview: truncated, isTruncated: true };
  } catch (error) {
    if (error instanceof Error && error.message.includes('circular')) {
      return { preview: '[Circular reference detected]', isTruncated: false };
    }
    return { preview: String(obj), isTruncated: false };
  }
}
